<template>
  <router-view />
</template>

<style lang="scss">
#gnt_center {
  display: none !important;
}
.gnt-notice-tabs {
  pointer-events: none;
}
.gnt-notice-tab {
  pointer-events: all;
}
</style>

<script>
export default {
  setup() {
    return {}
  },
}
</script>
